import type { Category } from '../../../../../workflows/quotes/prime-x/api/types/rater-x-preset';

export const useHasVisibleCoverages = (
  coveragesByCategory: Category
): boolean =>
  coveragesByCategory?.groups?.some((_group) => {
    return _group.coverages?.some(
      ({ isHidden, isSelected }) => !isHidden || isSelected
    );
  });
